import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 3h14a2 2 0 0 1 2 2v14.775a.5.5 0 0 1-.168.374l-1.75 1.556a.5.5 0 0 1-.664 0L16.5 20l-1.918 1.705a.5.5 0 0 1-.664 0L12 20l-1.918 1.705a.5.5 0 0 1-.664 0L7.5 20l-1.918 1.705a.5.5 0 0 1-.664 0l-1.75-1.556A.5.5 0 0 1 3 19.775V5a2 2 0 0 1 2-2zm2.194 9.224l3.448 2.666a.53.53 0 0 0 .71-.058l5.517-6a.489.489 0 0 0-.042-.706.53.53 0 0 0-.73.042l-5.192 5.645-3.065-2.37a.53.53 0 0 0-.727.078.49.49 0 0 0 .08.703z"
});

var SvgOrderReviewFilled = function SvgOrderReviewFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgOrderReviewFilled;